import React from 'react';
import { Carousel } from 'primereact/carousel';
import '../css/Galeria.css';


const Galeria = () => {

const images = [
  /*{ id: 1, src: '/images/Galeria/01.jpeg' },
  { id: 2, src: '/images/Galeria/02.png' },
  { id: 3, src: '/images/Galeria/03.jpg' },
  { id: 4, src: '/images/Galeria/04.jpg' },
  { id: 5, src: '/images/Galeria/05.png' },
  { id: 6, src: '/images/Galeria/06.png' },
  { id: 7, src: '/images/Galeria/07.jpeg' },
  { id: 8, src: '/images/Galeria/08.jpeg' },
  { id: 9, src: '/images/Galeria/09.png' },
  { id: 10, src: '/images/Galeria/10.jpg' },*/
  { id: 1, src: '/images/Galeria/16.jpeg' },
  { id: 2, src: '/images/Galeria/17.jpeg' },
  { id: 3, src: '/images/Galeria/15.jpeg' },
  { id: 4, src: '/images/Galeria/13.jpeg' },
  { id: 5, src: '/images/Galeria/11.jpeg' },
  { id: 6, src: '/images/Galeria/12.jpeg' },
  { id: 7, src: '/images/Galeria/14.jpeg' },
  { id: 8, src: '/images/Galeria/18.jpeg' },
  { id: 9, src: '/images/Galeria/19.jpeg' },
  
];
  const responsiveOptions = [    
    {
      breakpoint: '3000px',  // pantalla grande de escritorio
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: '1024px',
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: '600px',
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const imageTemplate = (item) => {
    return (
    
      <div className="galeria-item">
        <img src={item.src} alt={item.alt} className="galeria-img" />
      </div>

    );
  };

  return (
    <section className="galeria-section" id="Galeria">
    <h2 className="section-title">Galeria  Momentos</h2>
    <div className="galeria-wrapper">
      <Carousel 
      value={images}
      numVisible={3}
      numScroll={1}
      itemTemplate={imageTemplate} responsiveOptions={responsiveOptions} circular autoplayInterval={5000} />
    </div>
 </section>
  );
};

export default Galeria;

